import { FC, useState, useCallback } from 'react';
import userImage from 'src/assets/images/user.png';
import { useStyles } from './AddResource.styles';

interface AddResourceProps {
  name: string;
}

export const AddResource: FC<AddResourceProps> = ({ name }) => {
  const styles = useStyles();
  const [isModalResourceTypeOpen, setModalResourceTypeState] = useState(false);
  const toggleModalResourceType = useCallback(() => {
    setModalResourceTypeState(!isModalResourceTypeOpen);
  }, [isModalResourceTypeOpen]);

  return (
    <>
      <img src={userImage} alt="user-profile" className={styles.userIcon} />
      <div className={styles.titleGetStarted}>Hi {name}!</div>
      <div className={styles.subtitleGetStarted}>Adding and sharing a Resource is easy!</div>
      <button type="button" className={styles.buttonGetStarted} onClick={toggleModalResourceType}>
        <span className={styles.titleButtonGetStarted}>Get Started</span>
      </button>
    </>
  );
};
